import React, { useState } from 'react';
import { TicketingTab } from './tabs/ticketing/TicketingTab';
import './styles/TicketTab.css';

type TicketSubTab = 'ticketing';

export const TicketTab: React.FC = () => {
  const [activeTab, setActiveTab] = useState<TicketSubTab>('ticketing');

  const toggleOptions: [{ value: string; label: string }, { value: string; label: string }] = [
    { value: 'ticketing', label: 'Ticketing' },
    { value: 'ticketing', label: 'Ticketing' } // Placeholder for future second tab
  ];

  const renderContent = () => {
    switch (activeTab) {
      case 'ticketing':
        return <TicketingTab />;
      default:
        return <TicketingTab />;
    }
  };

  return (
    <div className="tt-tab">
      {/* Hero Header */}
      <div className="tt-hero">
        <div className="tt-hero-content">
          <h1>Ticket</h1>
          <p>Gestion des tickets et demandes</p>
        </div>
        <div className="tt-hero-decoration">
          <div className="tt-hero-circle tt-hero-circle-1"></div>
          <div className="tt-hero-circle tt-hero-circle-2"></div>
          <div className="tt-hero-circle tt-hero-circle-3"></div>
        </div>
      </div>

      {/* Toggle switch for sub-tabs - hidden for now since we only have one tab */}
      {/* When adding a second tab, uncomment this:
      <div className="tt-toggle-wrapper">
        <ToggleSwitch
          options={toggleOptions}
          value={activeTab}
          onChange={(value) => setActiveTab(value as TicketSubTab)}
          size="medium"
          colorScheme="default"
          aria-label="Sélectionner un onglet"
        />
      </div>
      */}

      <div className="tt-content">
        {renderContent()}
      </div>
    </div>
  );
};

export default TicketTab;
